<script setup>
import SpinnerLoader from "@/components/Spinner/SpinnerLoader.vue";
import { onMounted, ref, onBeforeUnmount, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useLoteStore } from "@/store/loteStore";
import { iniciarSesion } from "@/utils/usuarioRedirections";
import LoteSwiper from "./componentes/LoteSwiper.vue";
import LoteFicha from "./componentes/LoteFicha.vue";
import LoteLabel from "./componentes/LoteLabel.vue";
import LoteOfertas from "./componentes/LoteOfertas.vue";
import LoteGarantia from "./componentes/LoteGarantia.vue";
import LotePestanias from "./componentes/LotePestanias.vue";
import { useUsuarioStore } from "@/store/usuarioStore";
import { Modal } from "bootstrap";
import { redirigirSubastaPortada } from "@/utils/subastaRedirections";

// Instancia del store y la ruta
const loading = ref(true);
const route = useRoute();
const LoteStore = useLoteStore();
const usuarioStore = useUsuarioStore();

const lote = LoteStore.lote;

const isMobile = ref(false);

const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 992; // md de Bootstrap
};

onMounted(async () => {
  try {
    loading.value = true;
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    if (route.query.id) {
      await LoteStore.obtenerLote(route.query.id);
      if (lote.puja.length != 0) {
        await LoteStore.obtenerPuja(lote.subasta_id, lote.id);
        await LoteStore.obtenerAceptoTerminos(lote.subasta_id);
      }
      else {
        LoteStore.calcularCargos();
      }
    }
    

    loading.value = false;

    await nextTick();
  } catch (error) {
    console.error("Error al cargar:", error);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreenSize);
});

onMounted(async () => {
  await nextTick();
  if (localStorage.getItem(`prorroga_${LoteStore.lote.id}`) === "true") {
    const modal = new Modal(document.getElementById("prorrogaModal"));
    modal.show();
  }
});
</script>

<template>
  <div v-if="loading" class="spinner-overlay">
    <SpinnerLoader size="64px" />
  </div>

  <div class="container mt-4 text-soft-grey-74">
    <button
      @click="redirigirSubastaPortada(LoteStore.lote.subasta_id)"
      class="btn d-inline-flex align-items-center gap-1 text-soft-green mb-2 shadow-none bg-white"
    >
      <i class="fa fa-chevron-left fs-13 fw-semibold"></i>
      <span class="fs-13">Volver</span>
    </button>

    <div class="body-portada">
      <div class="subasta-portada">
        <LoteSwiper :LoteStore="LoteStore" />
      </div>
    </div>

    <div class="body my-4">
      <div class="row g-4">
        <!-- Columna izquierda -->
        <div class="col-lg-7">
          <LoteLabel :LoteStore="LoteStore" />

          <!-- LoteOfertas solo si hay puja -->
          <div v-if="isMobile">
            <LoteOfertas
              :LoteStore="LoteStore"
              :usuarioStore="usuarioStore"
            />
          </div>

          <div
            class="ficha mb-3"
            v-if="LoteStore.lote.caracteristicas.length != 0"
          >
            <LoteFicha :LoteStore="LoteStore" />
          </div>

          <LotePestanias :LoteStore="LoteStore" :usuarioStore="usuarioStore" />
        </div>

        <!-- Columna derecha -->
        <div class="col-lg-5">
          <div v-if="!isMobile">
            <LoteOfertas :LoteStore="LoteStore" />
          </div>
          <LoteGarantia v-if="LoteStore.lote.subasta?.tipo_credito?.slug !== 'sin-garantia'"
            :isLogged="usuarioStore.isLogged"
            @iniciarSesion="iniciarSesion"
          />
        </div>
      </div>
    </div>
  </div>
  <ProrrogaModal :LoteStore="LoteStore" />
</template>

<style>
.body-portada {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 1);
  /* fondo blanco con transparencia */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
